module.exports = __webpack_public_path__ + "1e44f293eeb9fd869fcb1cd5be45d1e3.svg";